/* eslint-disable @typescript-eslint/no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';

import { DspInsertionOrderUpdate, DspLineItem, DspStatusUpdate } from './dspApiTypes';
import {
  getInsertionOrdersStart,
  updateInsertionOrdersStart,
  updateStatusStart,
  getDspState,
  updateLineItemsStart,
  refreshDspMetadataStart,
} from './dspSlice';

export const useDsp = () => {
  const dispatch = useDispatch();
  const state = useSelector(getDspState);
  const insertionOrders = state.insertionOrders;
  const isLoading = state.isLoading;

  function getInsertionOrders(currentAdvertiserId: string) {
    dispatch(getInsertionOrdersStart(currentAdvertiserId));
  }

  function updateInsertionOrders(payload: DspInsertionOrderUpdate[]) {
    dispatch(updateInsertionOrdersStart(payload));
  }

  function updateLineItems(payload: DspLineItem[]) {
    dispatch(updateLineItemsStart(payload));
  }

  function updateStatus(payload: DspStatusUpdate) {
    dispatch(updateStatusStart(payload));
  }

  function refreshDspMetadata(dsp: string, entityType: string) {
    dispatch(refreshDspMetadataStart({ dsp, entityType }));
  }

  const errorText = state.error;

  return {
    insertionOrders,
    errorText,
    isLoading,
    getInsertionOrders,
    updateInsertionOrders,
    updateLineItems,
    updateStatus,
    refreshDspMetadata,
  };
};
